const translations = {
    body: 'Any unsaved changes will get lost if you leave this page.',
    confirmText: 'Leave Page',
    declineText: 'Stay On Page',
    title: 'Are you sure you want to leave?'
};

export default translations;
